import React, { useEffect } from "react";
import {
  TextField,
  Menu,
  createMuiTheme,
  MuiThemeProvider,
  Theme,
  FormControl,
  Select,
  MenuItem,
  Avatar,
  Snackbar,
  Button,
  Tooltip,
  withStyles
} from "@material-ui/core";
import { Send, ExpandMore } from "@material-ui/icons";
import uuid from "uuid/v4";
import clsx from "clsx";
import API, { graphqlOperation } from "@aws-amplify/api";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio, { RadioProps } from "@material-ui/core/Radio";
import RefreshIcon from '@material-ui/icons/Refresh';

import SendLogo from "./send.svg";
import { messageDataFont } from "../inputData/inputContant";
import { listConversationStarters } from "../../graphql/queries";
import SelectData from "./SelectData";
import { TalkTextData1 } from "./TabData/TabData1";
import invokeBot from "../../graphql/AI/invokeBot";
import { createMessage, createLexChatErrors } from "../../graphql/mutations";
// import useStyles from "./styles";

var AWS = require("aws-sdk");
AWS.config.region = "us-east-1";
AWS.config.accessKeyId = "AKIA4UWSNJXTBIABTO6L";
AWS.config.secretAccessKey = "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";

export const lambda = new AWS.Lambda({ region: "us-east-1" });

interface IInputTextFieldProps {
  botText: string;
  updateBotText: Function;
  dummyMessages: Array<any>;
  client: any;
  updateMessages: Function;
  authorId: String;
  activeConversation: any;
  autoSend: any;
  updateURLText: any;
  classes: any;
}

const theme = (theme: Theme) =>
  createMuiTheme({
    overrides: {
      MuiIconButton: {
        root: {
          padding: "0 12px 0 0"
        }
      },
      MuiMenu: {
        paper: {
          bottom: "10% !important",
          top: "unset !important"
        }
      },
      MuiInputBase: {
        root: {
          color: "#3f50b5",
          fontSize: "18px"
        }
      },
      MuiOutlinedInput: {
        input: {
          paddingLeft: "7px",
          [theme.breakpoints.down("sm")]: {
            fontSize: "11.8px"
          },
          [theme.breakpoints.up("md")]: {
            fontSize: "15px"
          },
          [theme.breakpoints.up("lg")]: {
            fontSize: "18px"
          },
        }
      }
    }
  });

const themes = createMuiTheme({
  overrides: {
    MuiMenu: {
      paper: {
        bottom: "10% !important",
        top: "unset !important"
      }
    }
  }
});

const InputTextField: React.FC<IInputTextFieldProps> = ({
  botText,
  updateBotText,
  dummyMessages,
  client,
  updateMessages,
  authorId,
  activeConversation,
  autoSend,
  updateURLText,
  classes
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openMain, setOpenMain] = React.useState(false);
  const [openMainImg, setOpenMainImg] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [keyData, setKeyData] = React.useState();
  const [openArrowImg, setopenArrowImg] = React.useState(true);
  const [valueData, setValueData] = React.useState();
  const [valueInatent, setValueInatent]: any = React.useState("Define");
  const [keyValue, setKeyValue] = React.useState();
  const [placeValue, setPlaceValue] = React.useState("Define Enter name of term");
  const [bottomNav, setBottomNav] = React.useState("0");
  const [authBucket, setAuthBucket] = React.useState("");
  const [authBucketInt, setAuthBucketInt] = React.useState("Define");
  const [shareOpen, setShareOpen] = React.useState(false);
  const [mainDataNew, setMainDataNew] = React.useState();
  const [anchorElFont, setAnchorElFont] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorElInt, setAnchorElInt] = React.useState<null | HTMLElement>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    listConversation();
  };

  const closeShare = () => {
    setShareOpen(false);
  };

  const listConversation = async () => {
    setOpenMain(!openMain);
    // Query using a parameter
    const userMutation: any = await API.graphql(
      graphqlOperation(listConversationStarters, {
        filter: {
          botname: { contains: "HoneyCode Glossary Chat" }
        },
        limit: 100
      })
    );
    const mutationResponse = await Promise.all([userMutation]);
    let DataMain =
      mutationResponse[0].data.listConversationStarters.items[0]
        .conversationStarter;
    let main = DataMain.map((data: any) => data.key);
    let MainKey = Object.keys(main);
    let mainValue = DataMain.map((data: any) => data.value);
    setValueData(mainValue);
    setKeyValue(MainKey);
    setKeyData(main);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    // if (localStorage.getItem("setIntent")) {
    //   if (localStorage.getItem("setIntent") == "Chapter") {
    //     updateBotText(localStorage.getItem("setIntent") + " " + "5");
    //   } else if (localStorage.getItem("setIntent") == "Line") {
    //     updateBotText(localStorage.getItem("setIntent") + " " + "10:1");
    //   } else if (localStorage.getItem("setIntent") == "Find") {
    //     updateBotText(localStorage.getItem("setIntent") + " " + "Sick");
    //   } else {
    //     updateBotText(localStorage.getItem("setIntent") + " " + "5");
    //   }
    //   setValueInatent(localStorage.getItem("setIntent"));
    // } else {
    //   updateBotText("");
    // }
    localStorage.setItem("Fontsize", "18");
    if (
      window.location.href.split("/")[3] &&
      window.location.href.split("/")[3] !== "#"
    ) {
      setOpenMain(false);
      setTimeout(() => {
        sendMessageToBot({
          sendToBot: true,
          defineMsg: window.location.href.split("/")[3].replace(/_/g, " ")
        });
      }, 1000);
      setopenArrowImg(false);
      updateURLText(window.location.href.split("/")[3]);
    }
  }, []);

  const handleCloseSnack = (
    event: React.SyntheticEvent | React.MouseEvent,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const LightTooltip = withStyles((theme: any) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 13
    }
  }))(Tooltip);

  const sendMessageToBot = async (data: any) => {
    if (openArrowImg === true) {
      setopenArrowImg(false);
    }
    // if (valueInatent && valueInatent) {
    //   setValueInatent("");
    //   localStorage.setItem("setIntent", "");
    // }
    localStorage.setItem("slugTerm", botText);
    if (data.sendToBot || data.keyCode == 13) {
      if (botText.trim().length === 0 && data.defineMsg === undefined) {
        return;
      }
      updateMessages([
        ...dummyMessages,
        {
          content: data.defineMsg ? data.defineMsg : botText,
          owner: "norpac-prod-user",
          createdAt: "sending..."
        }
      ]);
      try {
        // if (activeConversation.conversation.id !== null) {
        const userMutation = client.mutate({
          mutation: createMessage,
          variables: {
            input: {
              id: uuid(),
              content: data.defineMsg ? data.defineMsg : botText,
              owner: "norpac-prod-user",
              chatbot: false,
              isSent: true,
              messageConversationId:
                activeConversation.conversation.id !== null
                  ? activeConversation.conversation.id
                  : uuid()
            }
          }
        });

        updateBotText("");
        const response = await client.query({
          query: invokeBot,
          fetchPolicy: "network-only",
          variables: {
            bot: process.env.REACT_APP_BOT_NAME,
            text: data.defineMsg ? data.defineMsg : botText
          }
        });

        const botMutation = client.mutate({
          mutation: createMessage,
          variables: {
            input: {
              id: uuid(),
              content: JSON.parse(response.data.invokeBot.response),
              owner: authorId,
              chatbot: true,
              isSent: true,
              messageConversationId:
                activeConversation.conversation.id !== null
                  ? activeConversation.conversation.id
                  : uuid()
            }
          }
        });
        const mutationResponse = await Promise.all([userMutation, botMutation]);
        updateMessages([
          ...dummyMessages,
          mutationResponse[0].data.createMessage,
          mutationResponse[1].data.createMessage
        ]);
        return;
        // }
      } catch (e) {
        client.mutate({
          mutation: createLexChatErrors,
          variables: {
            input: {
              id: uuid(),
              botName: process.env.REACT_APP_BOT_NAME,
              content: JSON.stringify(e),
              owner: "norpac-prod-user",
              messageConversationId: " "
            }
          }
        });
        updateMessages([
          ...dummyMessages,
          {
            createdAt: new Date(),
            content:
              "Sorry, I'm unable to answer that. Please try a different question"
          }
        ]);
      }
    } else return;
  };

  const handleTextData = (event: any) => {
    updateBotText(event.target.value);
  };

  if (autoSend) {
    localStorage.setItem("slugTerm", autoSend);
    sendMessageToBot({ sendToBot: true });
  }

  const handleCloseFont = (event: any) => {
    setAuthBucket(event.target.value);
    setOpenMainImg(false);
    localStorage.setItem("Fontsize", event.target.value);
    setAnchorElFont(null);
  };

  const handleCloseFontInt = (event: any) => {
    setAuthBucketInt(event.target.value);
    setAnchorElInt(null);
    updateBotText(event.target.value);
  };

  const handleClickSample = async () => {
    var params = {
      FunctionName: "Honeycode-Randomize", // the lambda function we are going to invoke
      InvocationType: "RequestResponse",
      Payload: ""
    };
    lambda.invoke(params, function (err: any, data: any) {
      if (err) {
        console.log("Err ", err);
      } else {
        let mainData = JSON.parse(JSON.stringify(data));
        let allData = JSON.parse(mainData.Payload).body;
        let finalData = JSON.parse(allData).term;
        let BotLineData = "Define" + " " + finalData;
        localStorage.setItem("slugTermMain", BotLineData);
        setMainDataNew(BotLineData);
        setopenArrowImg(false);
        setTimeout(() => {
          sendMessageToBot({
            sendToBot: true,
            defineMsg: BotLineData
          });
        }, 10);
      }
    });
  };

  function StyledRadio(props: RadioProps) {
    return (
      <Radio
        className={classes.rootRadio}
        disableRipple
        color="default"
        checkedIcon={
          <span className={clsx(classes.icon, classes.checkedIcon)} />
        }
        icon={<span className={classes.icon} />}
        {...props}
      />
    );
  }

  const handleChangeLine = (event: any, value: any) => {
    setValueInatent(event.target.value);
    if (event.target.value == "Define") {
      setPlaceValue("Define Enter name of term");
    } else if (event.target.value == "Find") {
      setPlaceValue("Find (Enter ANY search term)");
    } else {
      setPlaceValue("Select a Radio Button above or use refresh arrow");
    }
    // updateBotText(event.target.value + " "); 
    // localStorage.setItem("setIntent", event.target.value);
  };

  const handleRefresh = () => {
    setPlaceValue("Select a Radio Button above or use refresh arrow");
    if (valueInatent && valueInatent) {
      setValueInatent("");
      updateBotText("");
      // localStorage.setItem("setIntent", "");
    }
  }

  return (
    <MuiThemeProvider theme={theme}>
      <div className="px-3 py-2 bg-light">
        <div
          style={{
            display: "flex",
            width: "100%",
            alignSelf: "center",
            justifyContent: "center"
          }}
        >
          {" "}
          <Button
            onClick={handleClickSample}
            style={{
              outline: "0px",
              textAlign: "right",
              marginLeft: "5px",
              flex: 1.5,
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              color: "#787878",
              fontSize: "15px",
              border: "0.5px solid",
              borderColor: "gray",
              marginBottom: "5px"
            }}
          >
            Randomize!
          </Button>
          <div
            style={{
              textAlign: "right",
              flex: 4,
              marginLeft: "40px"
            }}
          >
            <FormControl
              className={classes.inputBucketflow}
              style={{ float: "left" }}
            >
              {openMainImg === true ? (
                <Avatar src="font.png" className={classes.SelectImg}></Avatar>
              ) : (
                  ""
                )}
              <Select
                id="demo-simple-select"
                value={authBucket}
                onChange={handleCloseFont}
                style={{
                  color: "black",
                  backgroundColor: "white",
                  borderRadius: "3px",
                  background: "transparent"
                }}
              >
                {messageDataFont.map((item: any, index: any) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <span
              style={{
                display: "block",
                fontSize: "16px",
                color: "rgba(255, 152, 0, 1)",
                lineHeight: "29px",
                fontStyle: "italic"
              }}
            >
              {" "}
              Conversation Starters
            </span>
          </div>
          <ExpandMore
            style={{
              flex: 1,
              cursor: "pointer",
              fontSize: "30px",
              color: "#ff9800"
            }}
            onClick={listConversation}
          />
          <Menu
            open={openMain}
            onClose={() => {
              setOpenMain(false);
            }}
            className={classes.textMain}
          >
            {bottomNav ? (
              <>
                <div className={classes.appBarSpacer} />
                <TalkTextData1
                  classes={classes}
                  updateBotText={updateBotText}
                  setOpen={setOpenMain}
                  valueData={valueData && valueData[bottomNav]}
                />
              </>
            ) : (
                <>
                  <div className={classes.appBarSpacer} />
                  <TalkTextData1
                    classes={classes}
                    updateBotText={updateBotText}
                    setOpen={setOpenMain}
                    valueData={valueData && valueData[bottomNav]}
                  />
                </>
              )}
            <SelectData
              bottomNav={bottomNav}
              setBottomNav={setBottomNav}
              open={keyData}
              keyValue={keyValue}
            />
          </Menu>
        </div>
        <div style={{ width: "100%", height: "20%", marginLeft: "15px" }}>
          <FormControl component="fieldset">
            <RadioGroup
              // defaultValue="Chapter"
              aria-label="gender"
              name="customized-radios"
              style={{ display: "inline-block" }}
              value={valueInatent}
            >
              <RefreshIcon onClick={handleRefresh} style={{ marginRight: "10px", marginBottom: "7px" }} />
              <LightTooltip title="Define any Function" placement="bottom">
                <FormControlLabel
                  value="Define"
                  control={<StyledRadio />}
                  label="Define"
                  onChange={(event, value) => handleChangeLine(event, value)}
                />
              </LightTooltip>
              <LightTooltip
                title="Find any Function"
                placement="bottom"
              >
                <FormControlLabel
                  value="Find"
                  control={<StyledRadio />}
                  label="Find"
                  onChange={(event, value) => handleChangeLine(event, value)}
                />
              </LightTooltip>
            </RadioGroup>
          </FormControl>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <TextField
            id="message_here"
            label="Message"
            style={{
              height: 50,
              margin: 10,
              width: "95%",
              marginBottom: 30
            }}
            // "Your message here..."
            placeholder={placeValue}
            variant="outlined"
            value={botText}
            onChange={(event: any) => handleTextData(event)}
            onKeyDown={sendMessageToBot}
            InputLabelProps={{
              shrink: true
            }}
          />
          <img
            src={SendLogo}
            id="send_bot"
            onClick={() => {
              sendMessageToBot({ sendToBot: true });
            }}
            style={{
              width: "2rem",
              position: "absolute",
              right: 36,
              bottom: "48px"
            }}
          />
        </div>
      </div>
      <div style={{ position: "relative", width: "80%" }}>{/* <Drawer */}</div>
    </MuiThemeProvider>
  );
};

export default InputTextField;
